// extracted by mini-css-extract-plugin
export default {"upArrowContainer":"upArrowContainer__D8t5w","visible":"visible__UqHYf"};